// extracted by mini-css-extract-plugin
export var quantityInput = "_n7-0";